<template>
  <div class="page flex-col">
    <div class="block_1 flex-col justify-between">
      <HeadVue></HeadVue>
      <div class="group_3 flex-col">
        <div class="group_4 flex-row justify-between">
          <div class="group_5 flex-col"><div class="group_6 flex-col"></div></div>
          <div class="text-group_1 flex-col justify-between">
            <span class="text_6">千元级显卡即可运行</span>
            <span class="text_7">同性能下仅需要＜30%的私有化部署成本</span>
          </div>
        </div>
        <div class="group_7 flex-row justify-between">
          <div class="text-group_2 flex-col justify-between">
            <span class="text_8">大模型套件全家桶</span>
            <span class="paragraph_1">
              专业场景能力
              <br />
              定制化AI大模型服务解决方案
            </span>
          </div>
          <div class="group_8 flex-col"><div class="box_9 flex-col"></div></div>
        </div>
        <div class="group_9 flex-row justify-between">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png"
          />
          <div class="image-text_1 flex-row justify-between">
            <span class="text-group_3">全链条大模型应用与咨询服务</span>
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png"
            />
          </div>
        </div>
        <div class="group_10 flex-row">
          <div class="box_10 flex-col"></div>
          <div class="box_11 flex-row">
          </div>
          <div class="box_12 flex-col"></div>
          <div class="box_13 flex-col"></div>
          <div class="box_14 flex-col"></div>
        </div>
        <div class="text-wrapper_2 flex-row">
          <span class="paragraph_2">
            Agent开发全套
            <br />
            咨询和定制
          </span>
          <span class="paragraph_3">
            大模型中间件
            <br />
            咨询和定制
          </span>
          <span class="paragraph_4">
            高级Prompt
            <br />
            Engineering能力
          </span>
          <span class="paragraph_5">
            大模型
            <br />
            二次预训练
          </span>
          <span class="paragraph_6">
            微调模型
            <br />
            咨询与定制
          </span>
        </div>
        <!-- <div class="group_12 flex-col">
          <div class="group_13 flex-row">
            <div class="text-wrapper_3 flex-col justify-between">
              <span class="text_9">合作方式</span>
              <span class="text_10">联系人：xxx</span>
            </div>
            <div class="text-wrapper_4 flex-col justify-between">
              <span class="text_11">关于我们</span>
              <span class="text_12">企业介绍</span>
            </div>
            <div class="text-group_4 flex-col justify-between">
              <span class="text_13">新闻资讯</span>
              <span class="text_14">公司新闻</span>
            </div>
            <div class="text-wrapper_5 flex-col justify-between">
              <span class="text_15">关联平台</span>
              <span class="text_16">字节跳动</span>
            </div>
            <div class="text-wrapper_6 flex-col justify-between">
              <span class="text_17">联系我们</span>
              <span class="text_18">400xxxxxxxx</span>
            </div>
          </div>
          <div class="text-wrapper_7 flex-row">
            <span class="text_19">联系电话：15955555555</span>
            <span class="text_20">加入我们</span>
            <span class="text_21">抖音短视频</span>
            <span class="text_22">周一到周五:&nbsp;09:00-18:00</span>
          </div>
          <div class="group_14 flex-row justify-between">
            <span class="text_23">邮箱：15955555555&#64;qq.com</span>
            <div class="section_1 flex-col justify-between">
              <div class="list_1 flex-row">
                <div class="text-wrapper_8 flex-col justify-between" v-for="(item, index) in loopData0" :key="index">
                  <span class="text_24" v-html="item.lanhutext0"></span>
                  <span class="text_25" v-html="item.lanhutext1"></span>
                </div>
              </div>
              <div class="text-wrapper_9 flex-row justify-between">
                <span class="text_26">荣誉资质</span>
                <span class="text_27">抖音火山版</span>
              </div>
            </div>
            <div class="section_2 flex-col justify-between">
              <span class="text_28">周六到周日:&nbsp;10:00-18:30</span>
              <div class="group_15 flex-row justify-between">
                <div class="box_15 flex-col"></div>
                <div class="box_16 flex-col"></div>
              </div>
            </div>
          </div>
          <div class="text-wrapper_10 flex-row justify-between">
            <span class="text_29">企业微信服务</span>
            <span class="text_30">微信公众号</span>
          </div>
        </div> -->
        <FooterVue style="margin-top: 102px"></FooterVue>
        <!-- <div class="group_16 flex-col"></div>
        <div class="group_17 flex-col"></div>
        <div class="group_18 flex-col"></div>
        <div class="group_19 flex-col"><div class="block_4 flex-col"></div></div>
        <div class="group_20 flex-col"></div>
        <div class="group_21 flex-col"></div> -->
      </div>
      <div class="group_22 flex-col">
        <div class="image-wrapper_1 flex-row">
<!--          <img-->
<!--            class="image_4"-->
<!--            referrerpolicy="no-referrer"-->
<!--            src="./assets/img/MasterDDSSlicePNGa8a0fad51e0f896d95ea4c5536eeff87.png"-->
<!--          />-->
        </div>
        <div class="image-wrapper_2 flex-row">
<!--          <img-->
<!--            class="image_5"-->
<!--            referrerpolicy="no-referrer"-->
<!--            src="./assets/img/MasterDDSSlicePNGc364201db885ffa3f89f7281bb5e2eb5.png"-->
<!--          />-->
        </div>
        <div class="image-wrapper_3 flex-row">
<!--          <img-->
<!--            class="image_6"-->
<!--            referrerpolicy="no-referrer"-->
<!--            src="./assets/img/MasterDDSSlicePNGde9afab2ddb890d91390b26240aec15f.png"-->
<!--          />-->
        </div>
        <div class="group_23 flex-row">
          <div class="section_3 flex-col">
            <div class="group_24 flex-row justify-between">
              <img
                class="image_7"
                referrerpolicy="no-referrer"
                src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png"
              />
              <div class="image-text_2 flex-row justify-between">
                <span class="text-group_5">10年累计+全栈技术能力</span>
                <img
                  class="image_8"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png"
                />
              </div>
            </div>
            <div class="group_25 flex-row justify-between">
              <div class="box_17 flex-col">
                <div class="group_26 flex-row justify-between">
                  <div class="section_4 flex-col">
                    <img
                      class="label_1"
                      referrerpolicy="no-referrer"
                      src="./assets/img/MasterDDSSlicePNG1456b9656bd0dee100f82dd6af764341.png"
                    />
                    <div class="block_5 flex-col"></div>
                  </div>
                  <span class="text_31">算法</span>
                </div>
                <span class="text_32">•明晟自研s-can神经网络算法，更接近人类生物大脑的神经元网络架构</span>
                <span class="text_33">
                  •降低消耗与资源占用：自动对网络中不重要的神经元连接进行裁剪，从而降低无谓的运算消耗以及系统资源占用。
                </span>
              </div>
              <div class="box_18 flex-col">
                <div class="group_27 flex-row justify-between">
                  <div class="section_5 flex-col">
                    <img
                      class="label_2"
                      referrerpolicy="no-referrer"
                      src="./assets/img/MasterDDSSlicePNG415a89180b5b2017d39fcf2fc8b80a4f.png"
                    />
                    <div class="group_28 flex-col"></div>
                  </div>
                  <span class="text_34">算力</span>
                </div>
                <span class="text_35">•（拟筹建中）自建算力中心：降低长期成本，优化资源使用并增强数据处理能力。</span>
                <span class="text_36">•有效整合各方资源，推动数字化转型，更加高效地利用算力，实现战略目标。</span>
              </div>
            </div>
            <div class="group_29 flex-row justify-between">
              <img
                class="image_9"
                referrerpolicy="no-referrer"
                src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png"
              />
              <div class="image-text_3 flex-row justify-between">
                <span class="text-group_6">性能领先的基座大模型</span>
                <img
                  class="image_10"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png"
                />
              </div>
            </div>
            <div class="group_30 flex-row justify-between">
              <img
                class="image_11"
                referrerpolicy="no-referrer"
                src="./assets/img/MasterDDSSlicePNG66d065a22b4264356c1d73c5c1913967.png"
              />
              <div class="image-text_4 flex-row justify-between">
                <span class="text-group_7">专为工业企业设计</span>
                <img
                  class="image_12"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG85c2a6793dd491d988ca9acd2c26dd65.png"
                />
              </div>
            </div>
            <span class="paragraph_7">
              明晟大模型21亿参数在垂直领域已达
              <br />
              同行70-130亿参数效果
            </span>
          </div>
          <div class="text-wrapper_11 flex-col"><span class="text_37">更聪明灵活</span></div>
        </div>
        <div class="group_31 flex-row">
          <span class="text_38">明晟大模型，为工业企业应用而生</span>
          <div class="box_19 flex-col"><div class="block_6 flex-col"></div></div>
        </div>
        <div class="group_32 flex-col">
          <div class="section_6 flex-col">
            <div class="section_7 flex-row justify-between">
              <div class="box_20 flex-col">
                <img
                  class="label_3"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGc8fca6df759b84e4c878e176ccb65f6c.png"
                />
                <div class="group_33 flex-col"></div>
              </div>
              <span class="text_39">数据</span>
            </div>
            <span class="text_40">•海量优质数据源判断和储备</span>
            <span class="text_41">•万亿级多语语料抽取、结构化、质量评估全流程经验</span>
            <span class="text_42">•千亿级多粒度的大规模聚类系统</span>
          </div>
        </div>
        <div class="group_34 flex-col">
          <div class="section_8 flex-row justify-between">
            <div class="text-wrapper_12 flex-col"><span class="text_43">测试项目/大模型</span></div>
            <div class="text-wrapper_13 flex-col"><span class="text_44">任度</span></div>
            <div class="text-wrapper_14 flex-col"><span class="text_45">百度文心一言</span></div>
            <div class="text-wrapper_15 flex-col"><span class="text_46">讯飞星火</span></div>
            <div class="text-wrapper_16 flex-col"><span class="text_47">阿里通义千问</span></div>
          </div>
          <div class="section_9 flex-row justify-between">
            <div class="text-wrapper_17 flex-col"><span class="text_48">基础能力</span></div>
            <div class="group_35 flex-col justify-between">
              <div class="text-wrapper_18 flex-col"><span class="text_49">语言理解与生成</span></div>
              <div class="text-wrapper_19 flex-col"><span class="text_50">知识百科</span></div>
              <div class="text-wrapper_20 flex-col"><span class="text_51">专业能力</span></div>
              <div class="text-wrapper_21 flex-col">
                <span class="paragraph_8">
                  环境适应性
                  <br />
                  与安全
                </span>
              </div>
            </div>
            <div class="group_36 flex-col justify-between">
              <div class="text-wrapper_22 flex-col"><span class="text_52">语义理解与抽取</span></div>
              <div class="text-wrapper_23 flex-col"><span class="text_53">闲聊、自然对话</span></div>
              <div class="text-wrapper_24 flex-col"><span class="text_54">上下文对话</span></div>
              <div class="text-wrapper_25 flex-col"><span class="text_55">生成与创作</span></div>
              <div class="text-wrapper_26 flex-col"><span class="text_56">知识百科</span></div>
              <div class="text-wrapper_27 flex-col"><span class="text_57">计算</span></div>
              <div class="text-wrapper_28 flex-col"><span class="text_58">复杂逻辑推理</span></div>
              <div class="text-wrapper_29 flex-col"><span class="text_59">代码</span></div>
              <div class="text-wrapper_30 flex-col"><span class="text_60">角色扮演</span></div>
              <div class="text-wrapper_31 flex-col"><span class="text_61">伦理、安全</span></div>
            </div>
            <div class="group_37 flex-col justify-between">
              <div class="text-wrapper_32 flex-col"><span class="text_62">10</span></div>
              <div class="text-wrapper_33 flex-col"><span class="text_63">8</span></div>
              <div class="text-wrapper_34 flex-col"><span class="text_64">8</span></div>
              <div class="text-wrapper_35 flex-col"><span class="text_65">7</span></div>
              <div class="text-wrapper_36 flex-col"><span class="text_66">10</span></div>
              <div class="text-wrapper_37 flex-col"><span class="text_67">9</span></div>
              <div class="text-wrapper_38 flex-col"><span class="text_68">10</span></div>
              <div class="text-wrapper_39 flex-col"><span class="text_69">10</span></div>
              <div class="text-wrapper_40 flex-col"><span class="text_70">10</span></div>
              <div class="text-wrapper_41 flex-col"><span class="text_71">10</span></div>
            </div>
            <div class="group_38 flex-col justify-between">
              <div class="text-wrapper_42 flex-col"><span class="text_72">10</span></div>
              <div class="text-wrapper_43 flex-col"><span class="text_73">8</span></div>
              <div class="text-wrapper_44 flex-col"><span class="text_74">8</span></div>
              <div class="text-wrapper_45 flex-col"><span class="text_75">7</span></div>
              <div class="text-wrapper_46 flex-col"><span class="text_76">10</span></div>
              <div class="text-wrapper_47 flex-col"><span class="text_77">10</span></div>
              <div class="text-wrapper_48 flex-col"><span class="text_78">10</span></div>
              <div class="text-wrapper_49 flex-col"><span class="text_79">10</span></div>
              <div class="text-wrapper_50 flex-col"><span class="text_80">10</span></div>
              <div class="text-wrapper_51 flex-col"><span class="text_81">10</span></div>
            </div>
            <div class="group_39 flex-col justify-between">
              <div class="text-wrapper_52 flex-col"><span class="text_82">10</span></div>
              <div class="text-wrapper_53 flex-col"><span class="text_83">8</span></div>
              <div class="text-wrapper_54 flex-col"><span class="text_84">8</span></div>
              <div class="text-wrapper_55 flex-col"><span class="text_85">7</span></div>
              <div class="text-wrapper_56 flex-col"><span class="text_86">10</span></div>
              <div class="text-wrapper_57 flex-col"><span class="text_87">0</span></div>
              <div class="text-wrapper_58 flex-col"><span class="text_88">0</span></div>
              <div class="text-wrapper_59 flex-col"><span class="text_89">10</span></div>
              <div class="text-wrapper_60 flex-col"><span class="text_90">5</span></div>
              <div class="text-wrapper_61 flex-col"><span class="text_91">5</span></div>
            </div>
            <div class="group_40 flex-col justify-between">
              <div class="text-wrapper_62 flex-col"><span class="text_92">10</span></div>
              <div class="text-wrapper_63 flex-col"><span class="text_93">8</span></div>
              <div class="text-wrapper_64 flex-col"><span class="text_94">8</span></div>
              <div class="text-wrapper_65 flex-col"><span class="text_95">0</span></div>
              <div class="text-wrapper_66 flex-col"><span class="text_96">3</span></div>
              <div class="text-wrapper_67 flex-col"><span class="text_97">0</span></div>
              <div class="text-wrapper_68 flex-col"><span class="text_98">0</span></div>
              <div class="text-wrapper_69 flex-col"><span class="text_99">0</span></div>
              <div class="text-wrapper_70 flex-col"><span class="text_100">5</span></div>
              <div class="text-wrapper_71 flex-col"><span class="text_101">0</span></div>
            </div>
          </div>
          <div class="section_10 flex-row justify-between">
            <div class="text-wrapper_72 flex-col"><span class="text_102">基础能力总分</span></div>
            <div class="text-wrapper_73 flex-col"><span class="text_103">92</span></div>
            <div class="text-wrapper_74 flex-col"><span class="text_104">93</span></div>
            <div class="text-wrapper_75 flex-col"><span class="text_105">63</span></div>
            <div class="text-wrapper_76 flex-col"><span class="text_106">34</span></div>
          </div>
          <div class="section_11 flex-row justify-between">
            <div class="text-wrapper_77 flex-col"><span class="text_107">插件功能列表</span></div>
            <div class="box_21 flex-col justify-between">
              <div class="text-wrapper_78 flex-col"><span class="text_108">翻译功能</span></div>
              <div class="text-wrapper_79 flex-col"><span class="text_109">互联网功能</span></div>
              <div class="text-wrapper_80 flex-col"><span class="text_110">文件处理</span></div>
              <div class="text-wrapper_81 flex-col"><span class="text_111">数据库功能</span></div>
            </div>
            <div class="box_22 flex-col justify-between">
              <div class="text-wrapper_82 flex-col"><span class="text_112">多语翻译</span></div>
              <div class="text-wrapper_83 flex-col"><span class="text_113">在线信息检索</span></div>
              <div class="text-wrapper_84 flex-col"><span class="text_114">文档智能解析</span></div>
              <div class="text-wrapper_85 flex-col"><span class="text_115">文档生成</span></div>
              <div class="text-wrapper_86 flex-col"><span class="text_116">NL2SQL升级</span></div>
            </div>
            <div class="box_23 flex-col justify-between">
              <div class="image-wrapper_4 flex-col">
                <img
                  class="label_4"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_5 flex-col">
                <img
                  class="label_5"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_6 flex-col">
                <img
                  class="label_6"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="box_24 flex-row">
                <div class="image-text_5 flex-row justify-between">
                  <img
                    class="label_7"
                    referrerpolicy="no-referrer"
                    src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                  />
                  <span class="text-group_8">(规划中)</span>
                </div>
              </div>
              <div class="box_25 flex-row">
                <div class="image-text_6 flex-row justify-between">
                  <img
                    class="label_8"
                    referrerpolicy="no-referrer"
                    src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                  />
                  <span class="text-group_9">(内测中)</span>
                </div>
              </div>
            </div>
            <div class="box_26 flex-col justify-between">
              <div class="text-wrapper_87 flex-col"><span class="text_117">对话翻译,不支持文档</span></div>
              <div class="image-wrapper_7 flex-col">
                <img
                  class="label_9"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_8 flex-col">
                <img
                  class="label_10"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_9 flex-col">
                <img
                  class="label_11"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_10 flex-col">
                <img
                  class="label_12"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG346d28b076eea871d66645570b51029d.png"
                />
              </div>
            </div>
            <div class="box_27 flex-col justify-between">
              <div class="image-wrapper_11 flex-col">
                <img
                  class="label_13"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_12 flex-col">
                <img
                  class="label_14"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_13 flex-col">
                <img
                  class="label_15"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_14 flex-col">
                <img
                  class="label_16"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_15 flex-col">
                <img
                  class="label_17"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG346d28b076eea871d66645570b51029d.png"
                />
              </div>
            </div>
            <div class="box_28 flex-col justify-between">
              <div class="image-wrapper_16 flex-col">
                <img
                  class="label_18"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG346d28b076eea871d66645570b51029d.png"
                />
              </div>
              <div class="image-wrapper_17 flex-col">
                <img
                  class="label_19"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNGfbcaeae9ba94c6cb8b9f91a6df912c3c.png"
                />
              </div>
              <div class="image-wrapper_18 flex-col">
                <img
                  class="label_20"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG346d28b076eea871d66645570b51029d.png"
                />
              </div>
              <div class="image-wrapper_19 flex-col">
                <img
                  class="label_21"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG346d28b076eea871d66645570b51029d.png"
                />
              </div>
              <div class="image-wrapper_20 flex-col">
                <img
                  class="label_22"
                  referrerpolicy="no-referrer"
                  src="./assets/img/MasterDDSSlicePNG346d28b076eea871d66645570b51029d.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="group_41 flex-col"><div class="group_42 flex-col"></div></div>
      </div>
    </div>
  </div>
</template>
<script>
  import HeadVue from "../common/HeadVue.vue";
import FooterVue from "../common/FooterVue.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'index',
  components: {
    HeadVue,
    FooterVue
  },
  data() {
    return {
      loopData0: [
        { lanhutext0: '公司简介', lanhutext1: '团队介绍' },
        { lanhutext0: '今日头条', lanhutext1: '西瓜视频' }
      ],
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
